// Mock-Daten für die B2B-Landingpage Waldhotel Bad Essen

export const contactInfo = {
  phone: "+49 176 3241 9623",
  whatsapp: "4917632419623",
  email: "kontakt@waldhotel-badessen.de",
  address: {
    street: "Bergstraße 51",
    zip: "49152",
    city: "Bad Essen"
  },
  manager: "Mariya Düselder"
};

export const tagungsPauschale = {
  priceFrom: 69,
  includes: [
    "Getränke-Flatrate (Kaffee, Tee, Wasser, Cola & Cola Zero)",
    "Tagungsraum mit Tageslicht",
    "Beamer & Präsentationstechnik",
    "Highspeed-WLAN",
    "Moderationsmaterial"
  ],
  optional: [
    "Vital-Frühstück",
    "Mittagssuppe & Snack",
    "Nachmittags-Kaffee & Kuchen"
  ]
};

export const roomCapacity = {
  total: 20,
  closedHouse: "Ab ca. 20 Zimmern buchen Sie uns als geschlossene Gesellschaft"
};

export const faqData = [
  {
    question: "Wie viele Personen können Sie für Tagungen empfangen?",
    answer: "Unsere Tagungsräume bieten Platz für bis zu 30 Personen in verschiedenen Bestuhlung-Setups. Bei Buchung als geschlossene Gesellschaft (ca. 20 Zimmer) steht Ihnen das gesamte Hotel exklusiv zur Verfügung."
  },
  {
    question: "Welche technische Ausstattung steht zur Verfügung?",
    answer: "Jeder Tagungsraum verfügt über Beamer, Leinwand, Flipcharts, Moderationsmaterial und Highspeed-WLAN. Zusätzliche Technik können wir auf Anfrage organisieren."
  },
  {
    question: "Ist Parken am Hotel möglich?",
    answer: "Ja, kostenfreie Parkplätze stehen direkt am Haus für alle Gäste zur Verfügung. Auch für größere Gruppen ist ausreichend Parkraum vorhanden."
  },
  {
    question: "Können wir das Hotel exklusiv buchen?",
    answer: "Ja, ab einer Buchung von ca. 20 Zimmern wird das gesamte Hotel zu Ihrem privaten Business-Hub. Keine anderen Gäste, maximale Exklusivität für Ihr Team."
  },
  {
    question: "Bieten Sie auch Abendessen an?",
    answer: "Unser Fokus liegt auf Ihrer Tages-Performance. Wir bieten kein Abendessen im Haus an, sodass Ihr Team am Abend maximal flexibel für externe Teambuilding-Events oder Restaurantbesuche in Bad Essen bleibt."
  },
  {
    question: "Wie weit ist das Hotel vom nächsten Bahnhof entfernt?",
    answer: "Der Bahnhof Bad Essen ist ca. 2 km entfernt. Wir organisieren gerne Shuttle-Services für Ihre Gruppe auf Anfrage."
  },
  {
    question: "Gibt es Rückzugsorte für informelle Gespräche?",
    answer: "Absolut. Neben den Tagungsräumen bieten wir mehrere Lounge-Bereiche, einen weitläufigen Garten, eine Terrasse und ruhige Breakout-Räume – perfekt für 1-on-1-Gespräche und informelles Networking."
  },
  {
    question: "Wie funktioniert die Buchungsanfrage?",
    answer: "Kontaktieren Sie uns direkt per WhatsApp unter +49 176 3241 9623 oder nutzen Sie unser Anfrageformular. Wir melden uns innerhalb von 24 Stunden mit einem individuellen Angebot."
  }
];

export const mockFormSubmission = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Mock-Formular-Daten:", formData);
      resolve({
        success: true,
        message: "Ihre Anfrage wurde erfolgreich übermittelt. Wir melden uns innerhalb von 24 Stunden.",
        requestId: `REQ-${Date.now()}`
      });
    }, 1000);
  });
};
